import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ModuleTokens } from './services-base.constant';
import { reducer } from './services-base.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      ModuleTokens.Name,
      reducer
    )
  ]
})
export class ServicesBaseModule {

}
